import { idSchema } from "@izicvs/schema";
import { dateSchema } from "@izicvs/utils";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

import { secretsSchema } from "../secrets";

export const usernameSchema = z
  .string()
  .min(3)
  .max(255)
  .regex(/^[\w.-]+$/, {
    message: "Usernames can only contain letters, numbers, periods, hyphens, and underscores.",
  })
  .transform((value) => value.toLowerCase());

export const userSchema = z.object({
  id: idSchema,
  name: z.string().min(1).max(255),
  picture: z.literal("").or(z.null()).or(z.string().url()),
  username: usernameSchema,
  email: z
    .string()
    .email()
    .transform((value) => value.toLowerCase()),
  locale: z.string().default("fr-FR"),
  emailVerified: z.boolean().default(false),
  twoFactorEnabled: z.boolean().default(false),
  provider: z.enum(["email", "github", "google", "openid"]).default("email"),
  // Billing: exposed so the client can gate premium features and show status.
  plan: z.string().default("free"),
  currentPeriodEnd: dateSchema.nullable().default(null),
  createdAt: dateSchema,
  updatedAt: dateSchema,
});

export class UserDto extends createZodDto(userSchema) {}

// Server-side only: mirrors the remaining billing columns (never sent to the
// client, which only receives the fields declared on userSchema).
export const userWithSecretsSchema = userSchema.merge(
  z.object({
    stripeCustomerId: z.string().nullable().default(null),
    subscriptionId: z.string().nullable().default(null),
    subscriptionStatus: z.string().nullable().default(null),
    tokenBalance: z.number().default(0),
    templatesSubscriptionId: z.string().nullable().default(null),
    templatesPassStatus: z.string().nullable().default(null),
    templatesPassEnd: dateSchema.nullable().default(null),
    secrets: secretsSchema.nullable().default(null),
  }),
);

export class UserWithSecrets extends createZodDto(userWithSecretsSchema) {}
